import applyLicense from './applyLicense';
applyLicense();
export { default as applyLicense } from './applyLicense';
export * from '@mui/x-license-pro';